"use strict";

exports.__esModule = true;
exports.TabsThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Measures = require("../../Measures");
var _common = require("../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for TabsWidget.
 */
var TabsThumbnail = exports.TabsThumbnail = /*#__PURE__*/function (_Component) {
  function TabsThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(TabsThumbnail, _Component);
  var _proto = TabsThumbnail.prototype;
  _proto.render = function render() {
    var titleWidth = 140;
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(this.props), (0, _common.getWidgetInteractionProps)(this.props)), this.props.children.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: String(index)
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: index * titleWidth,
        y: 0,
        width: titleWidth,
        height: 80,
        fill: "#fff",
        stroke: "rgba(0, 0, 0, 0.05)",
        strokeWidth: 5
      }), /*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
        x: index * titleWidth + 10,
        y: 10,
        width: titleWidth - 20,
        height: 60,
        value: child.props.title
      }));
    }), this.props.children.length > 0 && this.renderChild(this.props.children[0], 0));
  };
  _proto.renderChild = function renderChild(child, index) {
    var _this$props = this.props,
      render = _this$props.render,
      width = _this$props.width,
      height = _this$props.height,
      orientation = _this$props.orientation;
    var childWidth = width;
    var childHeight = height;
    var childX = 0;
    var childY = 0;
    if (orientation === "vertical") {
      childWidth = width - 100;
      childX = 100;
    } else {
      childHeight = height - 60;
      childY = 70;
    }
    return render(Object.assign({}, child, {
      props: Object.assign({}, child.props, {
        x: childX,
        y: childY,
        width: childWidth,
        height: childHeight
      })
    }), index);
  };
  return TabsThumbnail;
}(_react.Component);
TabsThumbnail.defaultProps = {
  x: 0,
  y: 0
};